import * as React from 'react';
import { TypographyProps } from '@minecraft.atoms';

export interface OptionalProps {
  className?: string;
  qaId?: string;
  'data-testid'?: string;
}

export interface DropdownItemProps extends OptionalProps {
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  label?: string;
  disabled?: boolean;
  active?: boolean;
  divider?: boolean;
  header?: boolean;
  id: string;
  toggle?: boolean;
  color?: TypographyProps['color'];
}

export const buildOptionalProps = ({ 'data-testid': testIdProp, qaId, className }: OptionalProps) => {
  return {
    ...(typeof testIdProp === 'string' && testIdProp ? { 'data-testid': testIdProp } : {}),
    ...(typeof qaId === 'string' && qaId ? { 'data-qa-id': qaId } : {}),
    ...(typeof className === 'string' && className ? { className } : {}),
  };
};
